export const convertToGAIndex = (index: number) => index + 1;
